module.exports = __webpack_public_path__ + "static/media/gonzos_quest.netent.f6eb3b59.jpeg";